export function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-6xl px-4 py-6 text-sm text-slate-600">
        <p>&copy; {year} IGS Game Shows. All rights reserved.</p>
      </div>
    </footer>
  );
}
